import i18n from '../../../i18n';
import HttpService from '../../../services/HttpService';
import { GetSortOrder } from '../../helperFuncs';
import { getRegions, getRegionsOnly } from '../locations/fetchers';

export const getLanguages = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/languages`);
  const options = resp?.data.map((language: any) => {
    return {
      key: language,
      value: language
    };
  });
  return i18n.language === 'en'
    ? options.sort(GetSortOrder('key'))
    : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'));
};

export const getSpecialties = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/specialties`);
  const options_level_1 = resp?.data.level1.data?.map((specialty: any) => {
    return {
      key: specialty['o:title'],
      value: specialty['o:id'],
    };
  });

  const options_level_2 = resp?.data?.level2?.data?.map((location: any) => {
    const x = location?.['dcterms:relation'];
    if (!x) return;
    return {
      key: location?.['o:title'],
      value: location?.['o:id'],
      parent: x[0].display_title,
      parent_object: options_level_1.find((parent: any) => parent.key === x[0].display_title),
    };
  }).filter((value: any) => value);

  return {
    options_level_1: i18n.language === 'en'
      ? options_level_1.sort(GetSortOrder('key'))
      : options_level_1.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')),
    options_level_2: i18n.language === 'en'
      ? options_level_2.sort(GetSortOrder('parent'))
      : options_level_2.sort((a: any, b: any) => a.parent.localeCompare(b.parent, 'el'))
  };
};

export const getServices = async () => {
  const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/services`);
  const options = resp?.data.map((location: any) => {
    return {
      key: location,
      value: location
    };
  });
  return i18n.language === 'en'
    ? options.sort(GetSortOrder('key'))
    : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'));
};

export const getProfessionalsDropdownOptions = async () => {
  const [services, languages, regions, regions_only, specialties] = await Promise.all([
    getServices(),
    getLanguages(),
    getRegions(),
    getRegionsOnly(),
    getSpecialties(),
  ]);
  return {
    services,
    languages,
    regions,
    regions_only,
    specialty_level_1: specialties.options_level_1,
    specialty_level_2: specialties.options_level_2
  };
};

export const getProfessionalsFilterOptions = async () => {
  const [services, specialties] = await Promise.all([
    getServices(),
    getSpecialties(),
  ]);
  return {
    services,
    specialty_level_1: specialties.options_level_1,
    specialty_level_2: specialties.options_level_2
  };
};
export const updateProfessional = async (id: number, formData: FormData) => {
  const response = await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/professionals/${id}`, formData);
  return response;
};

export const createApplication = async (formData: FormData, prev_omeka_id?: string) => {
  const response = prev_omeka_id
    ? await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/applications/professionals?prev_omeka_id=${prev_omeka_id}`, formData)
    : await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/applications/professionals`, formData);
  return response;
};

export const getApplicationFiles = async (application_id: number) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/applications/professionals/files/${application_id}`);
  return response;
};

export const getProfessionalDetails = async (id: number) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/details/${id}`);
  return response;
};

export const getApplicationDetails = async (id: string) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/applications/professionals/${id}`);
  return response.data;
};

export const getApplicationDetailsOmeka = async (id: string) => {
  const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/omeka/${id}`);
  return response.data;
};